import { defineComponent as _defineComponent } from 'vue'
import copy from 'copy-to-clipboard';
import type { DefineComponent } from 'vue';
import { ref, toRefs } from '@nuxtjs/composition-api';
import type { Props as IconProps } from '~/core/components/base/image/SvgThemedIcon.vue';

interface Props {
    tag?: string | DefineComponent,
    value: string,
    copyTimeout?: number,
    icon?: IconProps,
    copiedIcon?: IconProps,
    hoverable?: boolean,
    hoverColor?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CopyToClipboard',
  props: {
    tag: { default: 'button' },
    value: null,
    copyTimeout: { default: 2000 },
    icon: { default: () => ({
        name: 'copy',
        path: 'actions'
    }) },
    copiedIcon: { default: () => ({
        name: 'check-blue-rounded',
        path: 'general'
    }) },
    hoverable: { type: Boolean, default: true },
    hoverColor: { default: 'var(--primary-surface-hover-focused)' }
  },
  emits: ['copy', 'reset'],
  setup(__props: any, { emit }) {

const props = __props as { tag: string | DefineComponent, value: string, copyTimeout: number, icon: IconProps, copiedIcon: IconProps, hoverable: boolean, hoverColor: string };





const {
    tag,
    value,
    copyTimeout,
    icon,
    copiedIcon,
} = toRefs(props);

const alreadyCopied = ref(false);

const handleClick = () => {
    copy(value.value);
    alreadyCopied.value = true;
    emit('copy');
    setTimeout(() => {
        alreadyCopied.value = false;
        emit('reset');
    }, copyTimeout.value);
};


return { __sfc: true,emit, props, tag, value, copyTimeout, icon, copiedIcon, alreadyCopied, handleClick }
}

})